module.exports = __webpack_public_path__ + "img/TC57X.0af39ec7.jpg";